import FitAssistantStep from '../Enums/FitAssistantStep';
import { CarInformation } from '../Types/FitAssistantData';
import { getBrand } from '../../../../../../../../../Foundation/Common/code/Helpers/TrackingHelper.js';

export const onFitAssistantOpen = (carInformation: CarInformation[]) => {
  if (typeof google !== 'undefined')
    window.google.tagmanager.add({
      event: 'FA_Open',
      ...getGTMCarInformation(carInformation),
    });
};

export const onFitAssistantSaveData = (carInformation: CarInformation[]) => {
  if (typeof google !== 'undefined')
    window.google.tagmanager.add({
      event: 'FA_Save',
      ...getGTMCarInformation(carInformation),
    });
};

const getGTMCarInformation = (carInformation: CarInformation[]) => {
  const brand = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Make)?.text;
  const year = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Year)?.text;
  const model = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Model)?.text;
  const variation = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Variation)?.text;

  return {
    brand: brand,
    year: year,
    model: model,
    variation: variation,
    selectedFilter: `${brand} ${model} ${year} | ${variation}`,
    url: window.location.href?.split('?')[0],
  };
};

export const GAtrackAddToCart = () => {
  let productDetail = window._THULEDATA.ProductDetail;
  let products = [
    {
      id: productDetail.ProductId || '',
      name: productDetail.WebTitle1 || '',
      price: (document.querySelector('.ga-price') as HTMLElement).innerText.trim(),
      metric2: (document.querySelector('.ga-discount-price') as HTMLElement).innerText.trim(),
      brand: getBrand(),
      category: window.adobeDataLayer.products[0].subcategory,
      variant: '',
      quantity: 1,
    },
  ];

  const analytics = {
    event: 'add_to_cart_NoFA',
    ecommerce: {
      currencyCode: (document.querySelector('.currencycode') as HTMLElement).innerText.trim(),
      add: {
        products,
      },
    },
  };

  google.tagmanager.add(analytics);
};
